export default {
    company: {
        label: window.i18n.__('Société'),
        bgcolor: '--colors-component-background-information-tag-subtle-brand',
    },
    person: {
        label: window.i18n.__('Particulier'),
        bgcolor: '--colors-component-background-information-tag-subtle-orange',
    },
    client: {
        label: window.i18n.__('Client'),
        bgcolor: '--colors-component-background-information-tag-subtle-light-blue',
    },
    prospect: {
        label: window.i18n.__('Prospect'),
        bgcolor: '--colors-component-background-information-tag-subtle-purple',
    },
    supplier: {
        label: window.i18n.__('Fournisseur'),
        bgcolor: '--colors-component-background-information-tag-subtle-coral',
    },
    contact: {
        label: window.i18n.__('Contact'),
        bgcolor: '--colors-component-background-information-tag-subtle-teal',
    },
    archived: {
        label: window.i18n.__('Archivé'),
        bgcolor: '--colors-component-background-information-tag-subtle-gray',
    },
};
